import { Stack, Text, XStack } from "tamagui";
import { useOrder } from "@utils/store/cart/useOrder";
import KioskIcon from "../KioskIcon";
import { kiosk } from "../kioskTheme";
import { useKiosk } from "../useKiosk";

/** 首頁底部購物車橫條（有商品才滑入；整條可點進購物車）。
 *  帶 total 時右側顯示金額；營業客戶（hidePrice）顯示「專員報價」；
 *  瓦斯行開啟 hide_amount_on_pending（下訂流程全程藏價）→ 金額整個不顯示（與購物車/結算頁一致）。 */
const FloatingCartBar = ({ count, total, pulse, onPress }: { count: number; total?: number; pulse: boolean; onPress: () => void }) => {
  const { hidePrice } = useKiosk();
  const { hideAmountOnPending } = useOrder();
  return (
  <XStack
    id={"kioskCartBar" as any}
    className={`gas-press kiosk-cartbar ${count > 0 ? "show" : ""}`}
    position="absolute"
    l={14}
    r={14}
    backgroundColor={kiosk.blue}
    borderRadius={999}
    px={18}
    py={14}
    ai="center"
    gap={12}
    cursor="pointer"
    onPress={onPress}
    // 點單機首頁掛在 APP 底部分頁列上方，手機安全區已由分頁列吃掉，這裡只留 16px 間距
    style={{ zIndex: 40, boxShadow: "0 3px 12px -6px rgba(29,111,255,.5)", bottom: 16 }}>
    <Stack position="relative">
      <KioskIcon name="cart" size={22} color="#fff" />
      <Stack
        className={pulse ? "kiosk-badge-pulse" : undefined}
        position="absolute"
        t={-8}
        r={-10}
        backgroundColor="#fff"
        minWidth={17}
        height={17}
        borderRadius={9}
        ai="center"
        jc="center"
        px={4}>
        <Text color={kiosk.blue} fontSize={10} fontWeight="800">
          {count}
        </Text>
      </Stack>
    </Stack>
    <Text color="#fff" fontSize={13} fontWeight="600">
      購物車 · {count} 件
    </Text>
    <XStack ml="auto" ai="center" gap={10}>
      {total != null &&
        !hideAmountOnPending &&
        (hidePrice ? (
          <Text color="#fff" fontSize={13} fontWeight="800">
            專員報價
          </Text>
        ) : (
          <Text color="#fff" fontSize={15} fontWeight="800">
            NT$ {total.toLocaleString()}
          </Text>
        ))}
      <Stack style={{ opacity: 0.85 }}>
        <KioskIcon name="chevron" size={22} color="#fff" />
      </Stack>
    </XStack>
  </XStack>
  );
};

export default FloatingCartBar;
